import React from 'react';
import '../styles/theme.css';
import '../styles/Landing.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import LandingStepRail from '../components/LandingStepRail';
import LandingEntryPanel from '../components/LandingEntryPanel';
/* IMPORTS */

function LandingPage() {
  const goToLogin = () =>
    new Promise((resolve, reject) => {
      try {
        window.location.assign('/login');
        resolve();
      } catch (err) {
        reject(err);
      }
    });

  return (
    <div className="la-root">
      <div className="la-layout-1">
        <div id="navbar" className="la-slot-navbar">
          <Navbar activePage={"Landing"} />
        </div>
        <div className="la-layout-2">
          <div id="landingsteprail" className="la-slot-landingsteprail">
            <LandingStepRail />
          </div>
          <div id="landingentrypanel" className="la-slot-landingentrypanel">
            <LandingEntryPanel onGoToLogin={goToLogin} />
          </div>
        </div>
        <div id="footer" className="la-slot-footer">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default LandingPage;